import { http } from '../utils/http';

export const leadHandler = {
  // getLeadersList: async ({ queryKey }) => {
  //   const [_key, { columnFilters, globalFilter, pagination, sorting, userId }] = queryKey;
  //   const searchText = globalFilter ?? null
  //   const sortingOrder = sorting?.[0]?.desc ? 'desc' : 'asc'
  //   const sortColumn = sorting?.[0]?.id
  //   return await http.get(`Leads/GetLeads?searchTerm=${searchText}&sortColumn=${sortColumn}&sortOrder=${sortingOrder}&page=${pagination.pageIndex + 1}&pageSize=${pagination.pageSize}&userId=${userId}`);
  // },
  getLeadersList: async (columnFilters, searchText, sortColumn, sortOrder, pageIndex, pageSize, userId, pipeLineId) => {
    const payLoad = {
      page: pageIndex + 1,
      pageSize,
      searchTerm: searchText,
      sortColumn,
      sortOrder,
      userId,
      pipeLineId,
      filter: {},
    };

    columnFilters?.forEach((item) => {
      payLoad.filter[item.id] = item.value;
    });

    if(!pipeLineId) {
      return
    }

    return await http.post('/Leads/GetLeads', payLoad);
  },
  getPipeLines: async () => {
    return await http.get('/Leads/GetPipeLines');
  },
  getPriorities: async () => {
    return await http.get('/Leads/GetPriorities');
  },
  createPipeLine: async (payload) => {
    return await http.post('/Leads/CreatePipeLine', payload);
  },
  updatePipeLine: async (payload) => {
    return await http.post('/Leads/UpdatePipeLine', payload);
  },
  createLead: async (payload) => {
    return await http.post('/Leads/CreateLead', payload);
  },
  updateLead: async (payload) => {
    return await http.patch('/Leads/UpdateLeads', payload);
  },
  deleteLeads: async (payload) => {
    return await http.post('/Leads/DeleteLead', payload);
  },
  createDuplicateLeads: async (leads, pipelineId) => {
    return await http.post(`/Leads/CreateDuplicateLeads?pipeline=${pipelineId}`, leads);
  },
  massUpdateLeadStatus: async (payload) => {
    return await http.post('/Leads/MassUpdateLeadStatus', payload);
  },
  assignLead: async (payload) => {
    return await http.patch('/Leads/AssignLead', payload);
  },
  notifyLeads: async (payload) => {
    return await http.patch('/Leads/NotifyLeads', payload);
  },
  getDetailedLead: async (leadId) => {
    return await http.get(`/Leads/GetDetailedLead?leadId=${leadId}`);
  },
  getLeadStatusTimeLine: async (leadId) => {
    return await http.get(`/Leads/GetLeadStatusTimeLine?leadId=${leadId}`);
  },
  getLeadSummaryOnStatus: async (pipeLineId, fromDate, toDate) => {
    return await http.get(
      `/Leads/GetLeadSummaryOnStatusByPipeLineId?pipeLineId=${pipeLineId}&from=${fromDate}&to=${toDate}`
    );
  },
  getWorkflowStatusByPipeLineId: async (pipelineId) => {
    return await http.get(`/Leads/GetWorkflowStatusByPipeLineId?pipeLineId=${pipelineId}`);
  },
  getWorkflowStatus: async () => {
    return await http.get('/Leads/GetWorkflowStatuses');
  },
  getWorkflowSubStatus: async () => {
    return await http.get('/Leads/GetWorkflowSubStatuses');
  },
  getWorkflowSubStatusByWorkflowId: async (workFlowId, pipeLineId) => {
    return await http.get(`/Leads/GetWorkflowSubStatusByWorkflowId?workFlowId=${workFlowId}&pipeLineId=${pipeLineId}`);
  },
  checkLeadExists: async (pipeLineId, phoneNumber) => {
    return await http.get(`/Leads/CheckLeadExists?pipeLineId=${pipeLineId}&phoneNumber=${phoneNumber}`);
  },
  createAction: async (payload) => {
    return await http.post('/Leads/CreateAction', payload);
  },
  createCallLogs: async (payload) => {
    return await http.post('/Leads/CreateCallLogs', payload);
  },
  createPaymentAudits: async (payload) => {
    return await http.post('/Leads/CreatePaymentAudit', payload);
  },
  createCustomerKyc: async (payload) => {
    return await http.post('/Leads/CreateCustomerKyc', payload);
  },
  updateCustomerKyc: async (payload) => {
    return await http.post('/Leads/UpdateCustomerKyc', payload);
  },
  createClientInfo: async (payload) => {
    return await http.post('/Leads/CreateClientBasicInfo', payload);
  },
  updateClientInfo: async (payload) => {
    return await http.post('/Leads/UpdateClientBasicInfo', payload);
  },
  createProcessAndProcedureCompleted: async (payload) => {
    return await http.post('/Leads/CreateClientProcessProcedure', payload);
  },
  updateProcessAndProcedureCompleted: async (payload) => {
    return await http.post('/Leads/UpdateClientProcessProcedure', payload);
  },
  createSiteDetails: async (payload) => {
    return await http.post('/Leads/CreateClientSiteDetail', payload);
  },
  updateSiteDetails: async (payload) => {
    return await http.post('/Leads/UpdateClientSiteDetail', payload);
  },
  createAdditionalServiceRequired: async (payload) => {
    return await http.post('/Leads/CreateClientAdditionalService', payload);
  },
  updateAdditionalServiceRequired: async (payload) => {
    return await http.post('/Leads/UpdateClientAdditionalService', payload);
  },
  createPcpDetails: async (payload) => {
    return await http.post('/Leads/CreateClientPackageAndPayment', payload);
  },
  updatePcpDetails: async (payload) => {
    return await http.post('/Leads/UpdateClientPackageAndPayment', payload);
  },
  createClientPersonalDetails: async (payload) => {
    return await http.post('/Leads/CreateClientPersonalInfo', payload);
  },
  updateClientPersonalDetails: async (payload) => {
    return await http.post('/Leads/UpdateClientPersonalInfo', payload);
  },
  createFeedbackAndSuggestions: async (payload) => {
    return await http.post('/Leads/CreateClientFeedbackAndSuggestions', payload);
  },
  updateFeedbackAndSuggestions: async (payload) => {
    return await http.post('/Leads/UpdateClientFeedbackAndSuggestions', payload);
  },
  createClientDesignDetail: async (payload) => {
    return await http.post('/Leads/CreateClientDesignDetail', payload);
  },
  updateLeadSubOwner: async (payload) => {
    return await http.patch(`/Leads/UpdateLeadSubOwner?userId=${payload?.userId}&pipeLineId=${payload?.pipeLineId}`, payload?.leadIds);
  },
  updateClientDesignDetail: async (payload) => {
    return await http.post('/Leads/UpdateClientDesignDetail', payload);
  },
  createClientResidentialBuildingDetail: async (payload) => {
    return await http.post('/Leads/CreateClientResidentialBuildingDetail', payload);
  },
  updateClientResidentialBuildingDetail: async (payload) => {
    return await http.post('/Leads/UpdateClientResidentialBuildingDetail', payload);
  },
  createClientConstructionSpecifications: async (payload) => {
    return await http.post('/Leads/CreateClientConstructionSpecifications', payload);
  },
  updateClientConstructionSpecifications: async (payload) => {
    return await http.post('/Leads/UpdateClientConstructionSpecifications', payload);
  },
};
